import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  allStaplesProgramOrders,
  getStaplesProgramOrder,
} from 'actions/orders';
import Pagination from 'components/Pagination';
import TextField from 'components/TextField';
import Button from 'components/Button';
import {
  AntTab,
  AntTabs,
} from 'pages/partn-brigham-and-womens-hosp-program/StyledTabs';
import OrderList from 'pages/partn-brigham-and-womens-hosp-program/AllOrdersList';
import { populateOrderData } from 'pages/partn-brigham-and-womens-hosp-program/helper';
import {
  PaginationWrapper,
  SearchWrapper,
} from 'styles/pages/staples-bulk-orders';

const take = 10;

const OrderTabs = ({ state, setState }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [searchPoNumber, setSearchPoNumber] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [orders, setOrders] = useState(null);
  const handleChange = (event, newValue) => {
    setCurrentPage(1);
    setValue(newValue);
  };

  const getOrdersData = async () => {
    const data = await dispatch(
      allStaplesProgramOrders({
        status: value === 0 ? 'Pending' : 'In-Production',
        searchString: value === 0 ? '' : searchPoNumber,
        skip: (currentPage === 0 ? currentPage : currentPage - 1) * take,
        take,
      })
    );
    setOrders(data);
  };

  useEffect(() => {
    getOrdersData();
  }, [value, currentPage]);

  return (
    <React.Fragment>
      <AntTabs value={value} onChange={handleChange}>
        <AntTab label="Pending Orders" />
        <AntTab label="In-Production Orders" />
      </AntTabs>

      {value === 1 && (
        <SearchWrapper>
          <TextField
            label="Search PO Number"
            size="small"
            type="number"
            value={searchPoNumber}
            onChange={(v) => setSearchPoNumber(v)}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                if (currentPage === 1) {
                  getOrdersData();
                } else {
                  setCurrentPage(1);
                }
              }
            }}
          />
          <Button
            title="Search"
            disabled={!searchPoNumber}
            onClick={() => {
              if (currentPage === 1) {
                getOrdersData();
              } else {
                setCurrentPage(1);
              }
            }}
          />
        </SearchWrapper>
      )}

      {!!orders?.orders?.length ? (
        <OrderList
          orders={orders?.orders}
          onSelect={async (v) => {
            const data = await dispatch(getStaplesProgramOrder({ ID: v?.ID }));
            const order = populateOrderData(data);

            const r = {
              orderPdfData: order?.data,
              additionalInfoWithLineItems: order?.additionalInfoWithLineItems,
              poPdfPath: order?.data?.pdfUrl,
              status: order?.data?.status,
              submittedOrdersModal: false,
              artProofUrl: data?.artProofUrl,
            };

            if (data?.success === false) {
              setState({
                ...state,
                poSubmittedModalVisibility: true,
                poSubmittedModalMessage: order?.data?.message,
                poSubmitted: false,
                ...r,
              });
              return;
            }

            setState({
              ...state,
              poSubmittedModalVisibility: true,
              poSubmittedModalMessage: order?.data?.message,
              poSubmitted: true,
              ...r,
            });
          }}
        />
      ) : (
        <h3 style={{ textAlign: 'center', color: 'red', marginTop: 40 }}>
          No data found !
        </h3>
      )}

      {orders?.ordersCount > 0 && (
        <PaginationWrapper>
          <Pagination
            totalCount={orders?.ordersCount}
            take={take}
            page={currentPage}
            onChange={(e, v) => setCurrentPage(v)}
          />
        </PaginationWrapper>
      )}
    </React.Fragment>
  );
};

export default OrderTabs;
